'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSignalCellularConnectedNoInternet4Bar = function MdSignalCellularConnectedNoInternet4Bar(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm3.4 36.6l33.2-33.2v10h-6.6v23.2h-26.6z m30 0v-3.2h3.2v3.2h-3.2z m0-6.6v-13.4h3.2v13.4h-3.2z' })
        )
    );
};

exports.default = MdSignalCellularConnectedNoInternet4Bar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/signal-cellular-connected-no-internet-4-bar.js
// module id = 1190
// module chunks = 0